// Common DataGrid styles for consistent appearance across the application
export const commonDataGridStyles = {
    height: '100%',
    '& .MuiDataGrid-root': {
        border: 1,
        borderColor: 'divider',
    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: 'background.paper',
        borderBottom: 2,
        borderColor: 'divider',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    '& .MuiDataGrid-cell': {
        borderBottom: 1,
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        fontSize: '0.875rem',
        padding: '8px 16px',
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: 'action.hover',
    },
    // Enhanced footer/pagination styling
    '& .MuiDataGrid-footerContainer': {
        borderTop: 2,
        borderColor: 'primary.main',
        backgroundColor: '#f5f5f5',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        '& .MuiTablePagination-root': {
            justifyContent: 'flex-start',
        },
        '& .MuiTablePagination-toolbar': {
            justifyContent: 'flex-start',
            padding: '8px 16px',
            '& .MuiTablePagination-selectLabel': {
                fontWeight: 600,
                color: 'primary.main',
            },
            '& .MuiTablePagination-displayedRows': {
                fontWeight: 500,
            },
            '& .MuiInputBase-root': {
                backgroundColor: 'white',
                border: '1px solid',
                borderColor: 'primary.main',
                borderRadius: 1,
                padding: '2px 8px',
                '&:hover': {
                    borderColor: 'primary.dark',
                },
            },
        },
        '& .MuiTablePagination-spacer': {
            display: 'none',
        },
    },
};

// Merge function to combine common styles with custom styles
export const mergeDataGridStyles = (customStyles = {}) => {
    return {
        ...commonDataGridStyles,
        ...customStyles,
        // Deep merge for nested objects
        ...(customStyles['& .MuiDataGrid-footerContainer'] && {
            '& .MuiDataGrid-footerContainer': {
                ...commonDataGridStyles['& .MuiDataGrid-footerContainer'],
                ...customStyles['& .MuiDataGrid-footerContainer'],
            }
        }),
    };
};